module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Breaking the German Dams")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("First published in 2023 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Greenhill Books,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("c/o Pen & Sword Books Ltd,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("George House, Unit 12 & 13,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Beevor Street, Off Pontefract Road,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Barnsley, South Yorkshire S71 1HN")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.greenhillbooks.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.greenhillbooks.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:contact@greenhillbooks.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("contact@greenhillbooks.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN: 978–1–78438–962–8")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("EPUB ISBN: 978–1–78438–963–5")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("MOBI ISBN: 978–1–78438–963–5")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("© Robert Owen, 2023")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The right of Robert Owen to be identified as author of this work have been asserted in accordance with Section 77 of the Copyrights, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("CIP data records for this title are available from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Edited and designed by Donald Sommerville")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Maps by Peter Wilkinson")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59084f46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 63
// module chunks = 0